import axios from 'axios';

const normalizeBaseUrl = (url) => (url.endsWith("/") ? url : `${url}/`);
const baseURL = normalizeBaseUrl(process.env.REACT_APP_API_URL || "/api/v1.0/frontend");
const instance = axios.create({ baseURL });

// Always attach the latest auth token from localStorage.
instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
});


// Add a 504 response interceptor (happens with database faults)
instance.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response) {
      if (error.response.status === 503) {
        if (error.response.data) {
          if (error.response.data.message) {
            alert(error.response.data.message)
          }
        }
      }
    }

    return Promise.reject(error);
});


export default instance;
